export default "__VITE_ASSET__4Sd3zj1A__"